// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "c1cf9dc87c54f68db6ec" + ".chunk.js";
};